module.exports = __webpack_public_path__ + "img/image_2_3.4a4121bd.png";